import { doGet } from '../http/httpHelper';

export const getProducts = async (cnpj) => {
    const resp = await doGet('/products', { cache: true, expireInSeconds: 3600 });
    if (resp.httpStatus !== 200) {
        throw resp.error;
    }
    if (Array.isArray(resp.body)) {
        resp.body.forEach((cat) => {
            if (Array.isArray(cat.Sub_categorias)) {
                cat.Sub_categorias = cat.Sub_categorias.filter(
                    (sub) =>
                        sub.Segmentos.filter((s) => s.Segmento !== 'Descartável').length > 0
                );
                cat.Sub_categorias.forEach((sub) => {
                    sub.produtos = sub.Segmentos.map((x) => x.produtos).flat();
                    delete sub.Segmentos;
                });
            }
        });
    }
    return resp.body;
};

export const getProductById = async (id) => {
    const resp = await queryProducts(
        null,
        id,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        '0',
        1
    );
    if (Array.isArray(resp.data) && resp.data.length > 0) {
        return resp.data[0];
    }
    return {};
};

export const getProductsByCodes = async (codes) => {
    if (!codes) return [];
    codes = codes.filter((x) => x !== undefined && x !== '' && x !== null);
    if (codes.length === 0) {
        return [];
    }
    const chunkSize = 100;
    let finalArray = [];
    for (let i = 0; i < codes.length; i += chunkSize) {
        const chunk = codes.slice(i, i + chunkSize);
        let url = `/productsByCodes?sapCode=${chunk.join(',')}`;
        finalArray = finalArray.concat(await doGet(url));
    }
    return finalArray;
};

export const getProductsImages = async (codes) => {
    if (!codes) return [];
    codes = codes.filter((x) => x !== undefined && x !== '' && x !== null);
    if (codes.length === 0) {
        return [];
    }
    const chunkSize = 100;
    let finalArray = [];
    for (let i = 0; i < codes.length; i += chunkSize) {
        const chunk = codes.slice(i, i + chunkSize);
        let url = `/productsImages?codes=${chunk.join(',')}`;
        finalArray = finalArray.concat(await doGet(url));
    }
    return finalArray;
};
export const getProductsGuides = async (codes) => {
    if (!codes) return [];
    codes = codes.filter((x) => x !== undefined && x !== '' && x !== null);
    if (codes.length === 0) {
        return [];
    }
    let url = `/productsGuides?codes=${codes.join(',')}`;
    return await doGet(url);
};

export const queryProducts = async (
    productId,
    sapCode,
    branch,
    categoryId,
    subCategoryId,
    segmentId,
    layout,
    type,
    searchText,
    page,
    pageSize
) => {
    let url = `/queryProducts?`;
    const params = [];
    if (productId && productId !== '') {
        params.push('productId=' + productId);
    }
    if (sapCode && sapCode !== '') {
        params.push('sapCode=' + sapCode);
    }
    if (branch && branch !== '') {
        params.push('branch=' + branch);
    }
    if (categoryId && categoryId !== '') {
        params.push('categoryId=' + categoryId);
    }
    if (subCategoryId && subCategoryId !== '') {
        params.push('subCategoryId=' + subCategoryId);
    }
    if (segmentId && segmentId !== '') {
        params.push('segmentId=' + segmentId);
    }
    if (layout && layout !== '') {
        params.push('layout=' + layout);
    }
    if (type && type !== '') {
        params.push('type=' + type);
    }
    if (searchText && searchText !== '') {
        params.push('searchText=' + searchText);
    }
    if (page && page !== '') {
        params.push('page=' + page);
    }
    if (pageSize && pageSize !== '') {
        params.push('pageSize=' + pageSize);
    }
    url = url + params.join('&');
    const resp = await doGet(url);
    return resp;
};

export const getSegments = async (page, pageSize) => {
    const cached = sessionStorage.getItem(`segments:${page}:${pageSize}`);
    if (cached) {
        const obj = JSON.parse(cached);
        if (new Date().getTime() - obj.timestamp < 1000 * 60 * 5) {
            return obj.data;
        }
    }
    let url = `/segments?`;
    const params = [];
    if (page && page !== '') {
        params.push('page=' + page);
    }
    if (pageSize && pageSize !== '') {
        params.push('pageSize=' + pageSize);
    }
    url = url + params.join('&');
    const resp = await doGet(url);
    sessionStorage.setItem(
        `segments:${page}:${pageSize}`,
        JSON.stringify({ timestamp: new Date().getTime(), data: resp })
    );
    return resp;
};

export const getCategories = async (id, page, pageSize, { bypassCache = false } = {}) => {
    const cacheKey = id ? `category:${id}` : `categories:${page}:${pageSize}`;
    const isValidResponse = (response) =>
        response && !(Number(response.httpStatus) >= 400) &&
        (id ? response.id != null : Array.isArray(response.data));

    try {
        const cached = sessionStorage.getItem(cacheKey);
        if (cached && !bypassCache) {
            const record = JSON.parse(cached);
            if (isValidResponse(record.data) && Date.now() - record.timestamp < 1000 * 60 * 5) {
                return record.data;
            }
        }
        sessionStorage.removeItem(cacheKey);
    } catch {
        // O catálogo continua disponível quando o cache está inválido ou indisponível.
    }

    let url = `/categories?`;
    if (id && id !== '') {
        url = `/categories/${id}`;
    } else {
        const params = [];
        if (page != null && page !== '') params.push('page=' + page);
        if (pageSize && pageSize !== '') params.push('pageSize=' + pageSize);
        url += params.join('&');
    }
    const response = await doGet(url);
    if (!isValidResponse(response)) {
        throw new Error('Não foi possível carregar o catálogo de terapias.');
    }
    try {
        sessionStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data: response }));
    } catch {
        // Falhas de armazenamento não devem impedir a exibição de uma resposta válida.
    }
    return response;
};
export const getSubCategories = async (id, page, pageSize) => {
    const cached = sessionStorage.getItem(`subcategories:${page}:${pageSize}`);
    if (cached) {
        const obj = JSON.parse(cached);
        if (new Date().getTime() - obj.timestamp < 1000 * 60 * 5) {
            return obj.data;
        }
    }
    let url = `/subcategories?`;
    if (id && id !== '') {
        url = `/subcategories?id=${id}`;
    } else {
        const params = [];
        if (page && page !== '') {
            params.push('page=' + page);
        }
        if (pageSize && pageSize !== '') {
            params.push('pageSize=' + pageSize);
        }
        url = url + params.join('&');
    }
    const resp = await doGet(url);
    sessionStorage.setItem(
        `subcategories:${page}:${pageSize}`,
        JSON.stringify({ timestamp: new Date().getTime(), data: resp })
    );
    return resp;
};

export const getProductPriority = async (branch) => {
    const cached = sessionStorage.getItem(`productPriority:${branch}`);
    if (cached) {
        const obj = JSON.parse(cached);
        if (new Date().getTime() - obj.timestamp < 1000 * 60 * 5) {
            return obj.data;
        }
    }
    let url = `/productPriority?`;
    if (branch && branch !== '') {
        url = `/productPriority?branch=${branch}`;
    }
    const resp = await doGet(url);
    sessionStorage.setItem(
        `productPriority:${branch}`,
        JSON.stringify({ timestamp: new Date().getTime(), data: resp })
    );
    return resp;
};
